var Vec3 = (function () {
    function Vec3(x, y, z) {
        if (x === void 0) { x = 0.0; }
        if (y === void 0) { y = 0.0; }
        if (z === void 0) { z = 0.0; }
        this.vector_ = new Float32Array([x, y, z]);
    }
    Object.defineProperty(Vec3.prototype, "x", {
        get: function () { return this.vector_[0]; },
        set: function (value) { this.vector_[0] = value; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "y", {
        get: function () { return this.vector_[1]; },
        set: function (value) { this.vector_[1] = value; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "z", {
        get: function () { return this.vector_[2]; },
        set: function (value) { this.vector_[2] = value; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "array", {
        get: function () {
            return this.vector_;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "from_array", {
        get: function () {
            return Array.from(this.vector_);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "length", {
        get: function () {
            return Math.sqrt(this.squared_length);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "squared_length", {
        get: function () {
            return Math.pow(this.x, 2) + Math.pow(this.y, 2) + Math.pow(this.z, 2);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec3.prototype, "orthogonal", {
        get: function () {
            return Math.abs(this.x) > Math.abs(this.z) ?
                new Vec3(-this.y, this.x, 0.0) :
                new Vec3(0.0, -this.z, this.y);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ;
    ;
    ;
    Vec3.fromArray = function (array) {
        var vector = new Vec3();
        vector.x = array[0] || 0.0;
        vector.y = array[1] || 0.0;
        vector.z = array[2] || 0.0;
        return vector;
    };
    ;
    Vec3.prototype.dot = function (a) {
        return this.x * a.x + this.y * a.y + this.z * a.z;
    };
    ;
    Vec3.prototype.cross = function (a, out) {
        if (out == undefined) {
            out = new Vec3();
        }
        out.x = (this.y * a.z) - (this.z * a.y);
        out.y = (this.z * a.x) - (this.x * a.z);
        out.z = (this.x * a.y) - (this.y * a.x);
        return out;
    };
    ;
    Vec3.prototype.normalise = function () {
        var length = this.length;
        var n = new Vec3();
        if (length > 0) {
            var factor = 1.0 / length;
            n = this.scale(factor);
        }
        return n;
    };
    ;
    Vec3.prototype.add = function (a) {
        var b = new Vec3();
        b.x = this.x + a.x;
        b.y = this.y + a.y;
        b.z = this.z + a.z;
        return b;
    };
    ;
    Vec3.prototype.subtract = function (a) {
        var b = new Vec3();
        b.x = this.x - a.x;
        b.y = this.y - a.y;
        b.z = this.z - a.z;
        return b;
    };
    ;
    Vec3.prototype.scale = function (scalar) {
        var v = new Vec3();
        v.x = this.x * scalar;
        v.y = this.y * scalar;
        v.z = this.z * scalar;
        return v;
    };
    ;
    Vec3.prototype.toString = function () {
        return "x: " + this.x + ", y: " + this.y + ", z: " + this.z;
    };
    ;
    Vec3.prototype.copy = function (a) {
        this.vector_[0] = a.x;
        this.vector_[1] = a.y;
        this.vector_[2] = a.z;
    };
    ;
    return Vec3;
}());
export { Vec3 };
;
export var vec3_up = new Vec3(0.0, 1.0, 0.0);
export var vec3_right = new Vec3(1.0, 0.0, 0.0);
export var vec3_forward = new Vec3(0.0, 0.0, -1.0);
//# sourceMappingURL=vec3.js.map